import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SfDeviceAttribute } from '../../shared/models/device.model';
import { trigger, animate, transition, style } from '@angular/animations';
import { DeviceTypeKeys } from '../../shared/models/device-types-attributes';

@Component({
  selector: 'app-device-sales-force',
  templateUrl: './device-sales-force.component.html',
  styleUrls: ['./device-sales-force.component.scss'],
  animations: [
    trigger('appear', [
      transition('* <=> *', [
        animate('0ms', style({ opacity: 0 })),
        animate('300ms ease-in', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class DeviceSalesForceComponent {
  @Input() sfDeviceAttribute: SfDeviceAttribute | undefined;
  @Input() bfAccessible: boolean | undefined;
  @Output() redirectEvent = new EventEmitter<DeviceTypeKeys>();

  protected selectId(type: DeviceTypeKeys) {
    this.redirectEvent.emit(type);
  }

  protected get deviceTypeKeys(): typeof DeviceTypeKeys {
    return DeviceTypeKeys;
  }

  protected get hasLocationList(): boolean {
    return Boolean(
      this.sfDeviceAttribute &&
        (this.sfDeviceAttribute.sfLocation ||
          this.sfDeviceAttribute.sfHall ||
          this.sfDeviceAttribute.sfGateSignal ||
          this.sfDeviceAttribute.sfGateControllerSide)
    );
  }

  protected get hasDeviceList(): boolean {
    return Boolean(
      this.sfDeviceAttribute &&
        (this.sfDeviceAttribute.sfDeviceType ||
          this.sfDeviceAttribute.deviceWidth ||
          this.sfDeviceAttribute.deviceLength ||
          this.sfDeviceAttribute.deviceHeight)
    );
  }
}
